import React, { Component } from 'react';
import { Content, TabsContainer, ScrollableExercisesContainer } from './style';
import { Tab as TabItem } from '../../../Components/Tab/style';
import { Tab, TabPanel } from '../../../Context/TabsContext';
import TabSwitcher from '../../../Context/TabsContext';
import { SearchInput } from '../../../Components/Inputs/SearchInput/SearchInput';
import { connect } from 'react-redux';
import { Exercise } from '../../../Components/Rows/ExerciseRow';
import { Loading } from '../../WithLoading/Loading';
import { EmptyState } from '../../WithEmptyState/EmptyState';
import {
    NoExercisesFoundState,
    UnauthorizedExercisesState,
} from '../../../Components/BannerEmptyStats/BannerEmptyStats';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';
import { getWorkoutType } from '../../../../Utils';
import InfiniteExercisesScroll from '../../../Components/InfiniteScroll/InfiniteExercisesScroll';
import { EXERCISE_SCROLL_TYPES } from '../../../../Store/ActionTypes/ExercisesActionTypes';
import { handleLoginService } from '../../../../Services/handleLocalStorage';
import { ExercisesActionCreators } from '../../../../Store/ActionCreators/ExercisesActionCreators';

class LeftBox extends Component {
    state = {
        searchQuery: '',
    };

    componentDidMount() {
        const { getAllExercises, getRecentExercises, getExercisesByType, workoutType } = this.props;
        const workoutTypeSearchKey = getWorkoutType(workoutType).toLocaleLowerCase();

        if (handleLoginService.isAuthenticated()) {
            getAllExercises();
            getExercisesByType(workoutTypeSearchKey);
            getRecentExercises();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.workoutType !== this.props.workoutType) {
            const workoutTypeSearchKey = getWorkoutType(this.props.workoutType).toLocaleLowerCase();
            this.props.getExercisesByType(workoutTypeSearchKey);
        }
    }

    addWorkoutExercise = exercise => {
        const { actions } = this.props;

        actions.addExercise(exercise);
    };

    makeSearchDelay = debounce(() => {
        const { getAllExercises, getExercisesByType, workoutType } = this.props;
        const workoutTypeSearchKey = getWorkoutType(workoutType).toLocaleLowerCase();

        getAllExercises(this.state.searchQuery);
        getExercisesByType(workoutTypeSearchKey, this.state.searchQuery);
    }, 200);

    handleChange = e => {
        this.setState({ searchQuery: e.target.value }, () => {
            this.makeSearchDelay();
        });
    };

    discardSearch = () => {
        this.setState({ searchQuery: '' }, () => {
            this.makeSearchDelay();
        });
    };

    render() {
        const {
            handleChange,
            discardSearch,
            state: { searchQuery },
            props: {
                allExercisesList,
                byTypeExercisesList,
                recentExercisesList,
                allExercisesLoading,
                recentExercisesLoading,
                byTypeExercisesLoading,
                workoutType,
            },
        } = this;

        const isAuthenticated = handleLoginService.isAuthenticated();

        return (
            <Content>
                <SearchInput
                    onDiscard={discardSearch}
                    onChange={handleChange}
                    value={searchQuery}
                    disabled={!handleLoginService.isAuthenticated()}
                    placeholder={'Search exercises to add'}
                />
                <TabSwitcher>
                    <TabsContainer>
                        <Tab id={0}>
                            <TabItem>All Exercises</TabItem>
                        </Tab>
                        <Tab id={1}>
                            <TabItem>{getWorkoutType(workoutType)}</TabItem>
                        </Tab>
                        <Tab id={2}>
                            <TabItem>Recent</TabItem>
                        </Tab>
                    </TabsContainer>

                    {/* ALL EXERCISES TAB */}
                    <TabPanel whenActive={0}>
                        <ScrollableExercisesContainer id={'all-exercises-scroll'}>
                            <Loading isLoading={allExercisesLoading}>
                                <EmptyState
                                    isEmpty={!allExercisesList.length}
                                    emptyState={isAuthenticated ? NoExercisesFoundState : UnauthorizedExercisesState}
                                >
                                    <InfiniteExercisesScroll
                                        filter={searchQuery}
                                        scrollType={EXERCISE_SCROLL_TYPES.ALL}
                                        scrollableTarget={'all-exercises-scroll'}
                                    >
                                        <MapExercises
                                            addExercise={this.addWorkoutExercise}
                                            exercises={allExercisesList}
                                        />
                                    </InfiniteExercisesScroll>
                                </EmptyState>
                            </Loading>
                        </ScrollableExercisesContainer>
                    </TabPanel>

                    {/* WORKOUT TYPE EXERCISES */}
                    <TabPanel whenActive={1}>
                        <ScrollableExercisesContainer id={'exercises-scroll-by-type'}>
                            <Loading isLoading={byTypeExercisesLoading}>
                                <EmptyState
                                    isEmpty={!byTypeExercisesList.length}
                                    emptyState={isAuthenticated ? NoExercisesFoundState : UnauthorizedExercisesState}
                                >
                                    <InfiniteExercisesScroll
                                        filter={searchQuery}
                                        scrollType={EXERCISE_SCROLL_TYPES.BY_TYPE}
                                        scrollableTarget={'all-exercises-scroll'}
                                    >
                                        <MapExercises
                                            addExercise={this.addWorkoutExercise}
                                            exercises={byTypeExercisesList}
                                        />
                                    </InfiniteExercisesScroll>
                                </EmptyState>
                            </Loading>
                        </ScrollableExercisesContainer>
                    </TabPanel>

                    {/* RECENT EXERCISES */}
                    <TabPanel whenActive={2}>
                        <ScrollableExercisesContainer>
                            <Loading isLoading={recentExercisesLoading}>
                                <EmptyState
                                    isEmpty={!recentExercisesList.length}
                                    emptyState={isAuthenticated ? NoExercisesFoundState : UnauthorizedExercisesState}
                                >
                                    <MapExercises
                                        addExercise={this.addWorkoutExercise}
                                        exercises={recentExercisesList}
                                    />
                                </EmptyState>
                            </Loading>
                        </ScrollableExercisesContainer>
                    </TabPanel>
                </TabSwitcher>
            </Content>
        );
    }
}

const MapExercises = ({ exercises, addExercise }) => {
    return exercises.map(exercise => (
        <Exercise
            key={exercise.id}
            icon={exercise.whiteImage}
            name={exercise.name}
            onClick={() => addExercise(exercise)}
        />
    ));
};

const mapStateToProps = ({
    exercises: {
        allExercises: { allExercisesList },
        recentExercises: { recentExercisesList },
        byTypeExercises: { byTypeExercisesList },
        statuses: { allExercisesLoading, recentExercisesLoading, byTypeExercisesLoading },
    },
}) => ({
    allExercisesList,
    recentExercisesList,
    byTypeExercisesList,
    allExercisesLoading,
    recentExercisesLoading,
    byTypeExercisesLoading,
});

const mapDispatchToProps = {
    getAllExercises: filter => ExercisesActionCreators.getAllExercisesRequest(filter),
    getRecentExercises: () => ExercisesActionCreators.getRecentExercisesRequest(),
    getExercisesByType: (key, filter) => ExercisesActionCreators.getExercisesByTypeRequest(key, filter),
};

LeftBox.propTypes = {
    actions: PropTypes.object.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LeftBox);



// WEBPACK FOOTER //
// ./src/UI/Containers/WorkoutPlan/LeftBox/index.js